import { apiEmpleo } from "../../util/ApiEmpleo";
import { TGetServicesCollectionItem } from "./service.types";

export interface IApiGetServices {
  itemsPerPage?: number;
  partial?: number;
  doNotLog?: number;
  page?: number;
  orSearch_searchFor?: string;
  businessCountry?: string;
  state?: string[];
  owner?: string[];
  "order[createdAt]"?: "desc" | "asc";
}

const apiGetServices = async (params: IApiGetServices) => {
  let res: {
    "hydra:member": TGetServicesCollectionItem[];
    "hydra:totalItems": number;
  } = await apiEmpleo.get("services", { params });

  return res;
};

export { apiGetServices };
